export default __webpack_public_path__ + "static/part3_1-49efe6bf4b2d3eff1eb9451808846fde.png";